function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 54 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 2h40a2 2 0 012 2v1.5H2V4a2 2 0 012-2zM0 7.5V4a4 4 0 014-4h40a4 4 0 014 4v35.5a4 4 0 01-4 4H4a4 4 0 01-4-4v-32zm2 24v8a2 2 0 002 2h11.75v-10H2zm15.75 0v10h14.5v-10h-14.5zm0-2v-10h14.5v10h-14.5zm-2-10v10H2v-10h13.75zm2-2h14.5v-10h-14.5v10zm-2-10v10H2v-10h13.75zM44 41.5h-9.75v-10H46v8a2 2 0 01-2 2zm2-12H34.25v-10H46v10zm0-12H34.25v-10H46v10z",
  fill: "url(#svg1308267801__paint0_linear)"
}), React.createElement("rect", {
  x: "6",
  y: "4.5",
  width: "48",
  height: "43.5",
  rx: "4",
  fill: "#F9EDFF"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 6.5h40a2 2 0 012 2V10H8V8.5a2 2 0 012-2zM6 12V8.5a4 4 0 014-4h40a4 4 0 014 4V44a4 4 0 01-4 4H10a4 4 0 01-4-4V12zm2 24v8a2 2 0 002 2h11.75V36H8zm15.75 0v10h14.5V36h-14.5zm0-2V24h14.5v10h-14.5zm-2-10v10H8V24h13.75zm2-2h14.5V12h-14.5v10zm-2-10v10H8V12h13.75zM50 46h-9.75V36H52v8a2 2 0 01-2 2zm2-12H40.25V24H52v10zm0-12H40.25V12H52v10z",
  fill: "url(#svg1308267801__paint1_linear)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg1308267801__paint0_linear",
  x1: "25.052",
  x2: "25.052",
  y2: "42",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})), React.createElement("linearGradient", {
  id: "svg1308267801__paint1_linear",
  x1: "31.052",
  y1: "4.5",
  x2: "31.052",
  y2: "46.5",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));